/**
 * ClusterIcon - Iconos de Leaflet para clusters de marcadores
 * V03 - Clustering de Marcadores
 *
 * Este archivo contiene las funciones que requieren Leaflet.
 * Las funciones puras están en clusterUtils.ts para permitir testing sin DOM.
 */

import L from 'leaflet';

// Re-exportar funciones puras desde clusterUtils
export {
  getClusterSize,
  getClusterColor,
  getClusterConfig,
  formatClusterCount,
  generateClusterHtml,
  CLUSTER_CONFIG,
} from './clusterUtils';

// Re-exportar tipos
export type {
  ClusterSize,
  ClusterSizeConfig,
  ClusterIconOptions,
} from './clusterUtils';

// Importar internamente para uso en este archivo
import { getClusterConfig, formatClusterCount } from './clusterUtils';

/**
 * Crea un icono de Leaflet DivIcon para un cluster
 * @param cluster - Objeto MarkerCluster de Leaflet
 * @returns L.DivIcon configurado con estilos PTEL
 */
export function createClusterIcon(cluster: L.MarkerCluster): L.DivIcon {
  const count = cluster.getChildCount();
  const config = getClusterConfig(count);
  const displayCount = formatClusterCount(count);

  return L.divIcon({
    html: `<div class="ptel-cluster ${config.className}">${displayCount}</div>`,
    className: 'ptel-cluster-container', // Container sin estilos extra
    iconSize: L.point(config.iconSize[0], config.iconSize[1]),
    iconAnchor: L.point(config.iconSize[0] / 2, config.iconSize[1] / 2),
  });
}

/**
 * Crea un icono de cluster a partir de opciones
 * Útil para crear iconos fuera del contexto de MarkerClusterGroup
 * @param options - Opciones del icono
 * @returns L.DivIcon configurado
 */
export function createClusterIconFromOptions(options: { count: number }): L.DivIcon {
  const { count } = options;
  const config = getClusterConfig(count);
  const displayCount = formatClusterCount(count);

  return L.divIcon({
    html: `<div class="ptel-cluster ${config.className}">${displayCount}</div>`,
    className: 'ptel-cluster-container',
    iconSize: L.point(config.iconSize[0], config.iconSize[1]),
    iconAnchor: L.point(config.iconSize[0] / 2, config.iconSize[1] / 2),
  });
}
